import orderService from '@/services/orderService';

// Add new patient API
export function addNewPatientApi(data) {
  return orderService({
    url: '/orderTest/patient',
    method: 'post',
    data
  });
}

export function searchPatientApi(params) {
  return orderService({
    url: '/orderTest/searchPatient',
    method: 'get',
    params
  });
}